// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getProfileAlbums = createAsyncThunk(
	"user-profile/galleries/getProfileAlbums",
	createApiCall(
		async ({ id, isAuth, showPrivateMedia = null, hash }, client) => {
			const response = await client.get(
				`/album${isAuth ? "" : "/unauthorized"}/all`,
				{
					params: {
						user: id,
						withMedia: true,
						showMedia: isAuth ? showPrivateMedia : null,
					},
				}
			);

			return {
				data: response.data,
				counters: response.counters,
				hash,
			};
		}
	)
);

// ############################################################
